import { TableCell, TableRow } from "@/components/ui/table";
import { flexRender, Table } from "@tanstack/react-table";
import { APIKey } from "../../types/app.type";
import { apiKeysColumns } from "./APIKeysColumn";

interface Props<TData> {
  table: Table<TData>;
}

function APIKeysTableBody<TData extends APIKey>({ table }: Props<TData>) {
  return table.getRowModel().rows?.length ? (
    table.getRowModel().rows.map((row) => (
      <TableRow className="h-12 group" key={row.id} data-testid="APIKeyRow">
        {row.getVisibleCells().map((cell) => (
          <TableCell
            className="[&:nth-last-child(-n+2)]:w-8 first:max-w-[1px] first:whitespace-nowrap first:text-ellipsis first:overflow-hidden"
            key={cell.id}
          >
            {flexRender(cell.column.columnDef.cell, cell.getContext())}
          </TableCell>
        ))}
      </TableRow>
    ))
  ) : (
    <TableRow>
      <TableCell colSpan={apiKeysColumns.length} className="text-center">
        No API keys found matching search
      </TableCell>
    </TableRow>
  );
}

export default APIKeysTableBody;
